import { render, staticRenderFns } from "./WechatMsgDetail.vue?vue&type=template&id=ab17b7ec&scoped=true&"
import script from "./WechatMsgDetail.vue?vue&type=script&lang=js&"
export * from "./WechatMsgDetail.vue?vue&type=script&lang=js&"
import style0 from "./WechatMsgDetail.vue?vue&type=style&index=0&id=ab17b7ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab17b7ec",
  null
  
)

export default component.exports